import React from 'react';
import { Link } from 'react-router-dom';
import { VStack, Button, Heading } from '@chakra-ui/react';

import SignInPage from './SignInPage';
import { Page } from '../../../types';
import { useTranslation } from 'react-i18next';

const SignOutPage: Page = () => {
  const { t } = useTranslation();
  return (
    <VStack
      spacing={0}
      gap={4}
      align="center"
      justify="center"
      minH="calc(100vh - 60px - 88px)"
      style={{ alignItems: 'center', textAlign: 'center' }}
      mx="auto"
      maxW="500px"
      padding="10px"
    >
      <Heading as="h3" size="xl" color="blue.500" mb={4}>
        {t('signOutPage.successfulSignOut')}
      </Heading>
      <Button
        variant="outline"
        colorScheme="blue"
        size="lg"
        as={Link}
        to={SignInPage.getRoute()}
      >
        {t('signInPage.signIn')}
      </Button>
    </VStack>
  );
};

SignOutPage.getRoute = () => '/sign-out/';

export default SignOutPage;
